import axios from "axios";
import Vue from "vue";
import {eventBus, vm} from "@/main";

export default class Api {

	static LoginCheckCode(code, success) {
		axios.get(Vue.config.API_URL + `login_code/` + code)
			.then(response => {

				if (response.data.type == "success") {
					success(response.data);
				}
			})
			.catch(e => {
				//console.log(e);
			})
	}

	static  loadLead(lead_id,success){
		var api_token = localStorage.getItem('api_token');


		axios.defaults.headers.common['Authorization'] = `Bearer ` + api_token;


		axios.get(Vue.config.API_URL + 'lead/get/'+lead_id)
			.then(function (resp) {


				success(resp.data);




			})
			.catch(function () {

			});
	}
	static loadSaveProjectFields(params,success,projectid=null){
		params.is_need_update=true;
		var param_url=new URLSearchParams(params).toString();
		const searchParams = new URLSearchParams();

		Object.keys(params).forEach(key => searchParams.append(key, params[key]));
 		param_url=searchParams.toString();
 		if(projectid){
 			param_url=param_url+"&projectid="+projectid;
		}

		var api_token = localStorage.getItem('api_token');
		axios.defaults.headers.common['Authorization'] = `Bearer ` + api_token;
		axios.get(Vue.config.API_URL + 'projects/savefields?'+param_url)
			.then(function (resp) {


				success(resp.data);




			})
			.catch(function () {

			});
	}
	static loadAccount(success){
		axios.get(Vue.config.API_URL + 'myaccount',)
			.then(function (resp) {


				success(resp.data);




			})
			.catch(function () {

			});
	}
	static changeManageSpectator(projectId,manage_spectator,success){

		var api_token = localStorage.getItem('api_token');

		axios.defaults.headers.common['Authorization'] = `Bearer ` + api_token;

		axios.get(Vue.config.API_URL + 'projects/setmanagespectator/'+projectId+"/"+manage_spectator,)
			.then(function (resp) {

				if(resp.data.type=="success" )	{
					success(resp.data.manage_spectator);
				}





			})
			.catch(function () {

			});
	}
	static loadProjectFields(params,success,projectId=null){
		var param_url=new URLSearchParams(params).toString();
		var api_token = localStorage.getItem('api_token');

		axios.defaults.headers.common['Authorization'] = `Bearer ` + api_token;
		if(projectId){
			param_url=param_url+"&projectid="+projectId;
		}
		axios.get(Vue.config.API_URL + 'projects/fields?'+param_url,)
			.then(function (resp) {


				success(resp.data);




			})
			.catch(function () {

			});
	}
	static loadFunnel(funnel_id,success){
		var api_token = localStorage.getItem('api_token');


		axios.defaults.headers.common['Authorization'] = `Bearer ` + api_token;


		axios.get(Vue.config.API_URL + 'funnels/get/'+funnel_id)
			.then(function (resp) {


					success(resp.data);




			})
			.catch(function () {

			});
	}
	static loadLeadFields(success){
		var api_token = localStorage.getItem('api_token');


		axios.defaults.headers.common['Authorization'] = `Bearer ` + api_token;


		axios.get(Vue.config.API_URL + 'lead/fields')
			.then(function (resp) {


				success(resp.data);


			})
			.catch(function () {

			});

	}
	static confirmOrder(secretId,success){
		axios.get(Vue.config.API_URL + 'lead/confirmorder/'+secretId)
			.then(function (resp) {

				if(resp.data.type=="success") {
					success(resp.data);
				}


			})
			.catch(function () {

			});
	}
	static acceptInviteLinkToProject(id,code,success){
		axios.get(Vue.config.API_URL + 'invite/accept/'+id+'/'+code)
			.then(function (resp) {

				if(resp.data.type=="success") {
					success(id);
				}else {
					alert(resp.data.message);
				}


			})
			.catch(function () {

			});
	}
	static loadInviteToProject(id,code,success){
		axios.get(Vue.config.API_URL + 'invite/load/'+id+'/'+code)
			.then(function (resp) {

				if(resp.data.type=="success") {
					success(resp.data.name);
				}


			})
			.catch(function () {

			});
	}
	static loadOrder(secretId,success){
		axios.get(Vue.config.API_URL + 'lead/userorder/'+secretId)
			.then(function (resp) {

				if(resp.data.type=="success") {
					success(resp.data);
				}


			})
			.catch(function () {

			});
	}

	static download_pdf_offer(tag){
		window.open(Vue.config.API_URL+"download_portfolio/"+tag);
	}

	static saveMap(project_id,map,success,error){
		var api_token = localStorage.getItem('api_token');


		axios.defaults.headers.common['Authorization'] = `Bearer ` + api_token;


		var params={};
		params['map']=map;


		axios.post(Vue.config.API_URL + 'projects/savemap/'+project_id, params)
			.then(function (resp) {

				if (resp.data.type == "success") {

					success(resp.data);
				} else {
					error(resp.data.message);
				}


			})
			.catch(function () {
				error("Произошла ошибка!");
			});

	}
	static getMap(project_id,success){
		var api_token = localStorage.getItem('api_token');


		axios.defaults.headers.common['Authorization'] = `Bearer ` + api_token;


		axios.get(Vue.config.API_URL + 'projects/getmap/'+project_id)
			.then(function (resp) {


				success(resp.data);


			})
			.catch(function () {

			});
	}

	static searchTasks(project_id,q,success){
		var api_token = localStorage.getItem('api_token');


		axios.defaults.headers.common['Authorization'] = `Bearer ` + api_token;


		axios.get(Vue.config.API_URL + 'projects/searchtasks/'+project_id+'?q='+q)
			.then(function (resp) {


				success(resp.data);


			})
			.catch(function () {

			});
	}
	static searchLead(q,success){
		var api_token = localStorage.getItem('api_token');


		axios.defaults.headers.common['Authorization'] = `Bearer ` + api_token;


		axios.get(Vue.config.API_URL + 'lead/search?q='+q)
			.then(function (resp) {


				success(resp.data);


			})
			.catch(function () {

			});
	}
	static loadFunnels(success){
		var api_token = localStorage.getItem('api_token');


			axios.defaults.headers.common['Authorization'] = `Bearer ` + api_token;


		axios.get(Vue.config.API_URL + 'funnels/all')
			.then(function (resp) {


				success(resp.data);


			})
			.catch(function () {

			});

	}
	static loadCategoryPosts(alias,limit,offset,success){
		var api_token = localStorage.getItem('api_token');
		if (api_token) {

			axios.defaults.headers.common['Authorization'] = `Bearer ` + api_token;

		}
		axios.get(Vue.config.API_URL + 'blog/category/'+alias+'/' + limit + '/' + offset)
			.then(function (resp) {

				if(resp.data.type=="success") {
					success(resp.data);
				}


			})
			.catch(function () {

			});
	}
	static loadPosts(limit, offset, success) {
		var api_token = localStorage.getItem('api_token');
		if (api_token) {

			axios.defaults.headers.common['Authorization'] = `Bearer ` + api_token;

		}
		axios.get(Vue.config.API_URL + 'blog/all/' + limit + '/' + offset)
			.then(function (resp) {


				success(resp.data);


			})
			.catch(function () {

			});
	}

	static deleteCommentPost(comment_id, post_id, success) {
		axios.get(Vue.config.API_URL + 'blog/delcomment/' + comment_id + '/' + post_id)
			.then(function (resp) {


				if (resp.data.type == "success") {
					success(resp.data);
				}


			})
			.catch(function () {

			});
	}

	static deleteSubCommentPost(subcomment_id, comment_id, post_id, success) {

		axios.get(Vue.config.API_URL + 'blog/delsubcomment/' + subcomment_id + '/' + comment_id + '/' + post_id)
			.then(function (resp) {


				if (resp.data.type == "success") {
					success(resp.data);
				}


			})
			.catch(function () {

			});
	}

	static loadPost(id, success) {


		(async (id, success) => {

			var api_token = await localStorage.getItem('api_token');

			if (api_token) {

				axios.defaults.headers.common['Authorization'] = `Bearer ` + api_token;

			}
			axios.get(Vue.config.API_URL + 'blog/post/' + id)
				.then(function (resp) {

					if (resp.data.type && resp.data.type == "success") {
						success(resp.data.post);
					}


				})
				.catch(function () {

				});

		})(id, success);

	}

	static loadPage(id, success) {
		axios.get(Vue.config.API_URL + 'page/' + id)
			.then(function (resp) {

				if (resp.data.type && resp.data.type == "success") {
					success(resp.data.page);
				}


			})
			.catch(function () {

			});
	}

	static loadPages(success) {

		axios.get(Vue.config.API_URL + 'pages')
			.then(function (resp) {


				success(resp.data);


			})
			.catch(function () {

			});
	}

	static loadAboutService(service_id,success){
		axios.get(Vue.config.API_URL + 'about/service/'+service_id)
			.then(function (resp) {


				if(resp.data.type=="success"){
					success(resp.data);
				}



			})
			.catch(function (e) {
				console.log('err');
				console.log(e);
				//alert('errr');
			});
	}
	static loadAboutWorks_in_cat(category_id,success){
		axios.get(Vue.config.API_URL + 'about/works_in_cat/'+category_id)
			.then(function (resp) {


				if(resp.data.type=="success"){
					success(resp.data);
				}



			})
			.catch(function (e) {
				console.log('err');
				console.log(e);
				//alert('errr');
			});
	}
	static loadAboutcategorys_portfolio(success){
		axios.get(Vue.config.API_URL + 'about/categorys_portfolio')
			.then(function (resp) {


				success(resp.data);


			})
			.catch(function (e) {
				console.log('err');
				console.log(e);
				//alert('errr');
			});
	}
	static loadAbout(success) {

		axios.get(Vue.config.API_URL + 'about')
			.then(function (resp) {


				success(resp.data);


			})
			.catch(function () {

			});
	}

	static loadStatsInvoices(success) {
		axios.defaults.headers.common['Authorization'] = `Bearer ` + vm.$store.getters.TOKEN;
		axios.get(Vue.config.API_URL + 'invoices/stats')
			.then(function (resp) {


				success(resp.data);


			})
			.catch(function () {

			});
	}

	static loadStats(success) {

		axios.defaults.headers.common['Authorization'] = `Bearer ` + vm.$store.getters.TOKEN;
		axios.get(Vue.config.API_URL + 'projects/stats')
			.then(function (resp) {


				success(resp.data);


			})
			.catch(function () {

			});
	}

	static setReadAllNotify(success) {
		axios.defaults.headers.common['Authorization'] = `Bearer ` + vm.$store.getters.TOKEN;
		axios.get(Vue.config.API_URL + 'notify/readall')
			.then(function (resp) {


				success(resp.data);


			})
			.catch(function () {

			});
	}

	static setRemoveNotify(notify_id, success) {
		axios.defaults.headers.common['Authorization'] = `Bearer ` + vm.$store.getters.TOKEN;
		axios.get(Vue.config.API_URL + 'notify/remove/' + notify_id)
			.then(function (resp) {


				success(resp.data);


			})
			.catch(function () {

			});
	}

	static setReadNotify(notify_id, success) {
		axios.defaults.headers.common['Authorization'] = `Bearer ` + vm.$store.getters.TOKEN;
		axios.get(Vue.config.API_URL + 'notify/setread/' + notify_id)
			.then(function (resp) {


				success(resp.data);


			})
			.catch(function () {

			});
	}

	static loadNotifyCount(success) {
		axios.defaults.headers.common['Authorization'] = `Bearer ` + vm.$store.getters.TOKEN;
		axios.get(Vue.config.API_URL + 'notify/count')
			.then(function (resp) {


				success(resp.data);


			})
			.catch(function () {

			});
	}

	static sendReview(params, id, success) {
		axios.defaults.headers.common['Authorization'] = `Bearer ` + vm.$store.getters.TOKEN;
		axios.post(Vue.config.API_URL + 'invoices/sendreview/' + id, params)
			.then(function (resp) {

				if (resp.data.type == "success") {

					success(resp.data);
				} else {
					error(resp.data.message);
				}


			})
			.catch(function () {
				error("Произошла ошибка!");
			});
	}

	static loadNotify(params, success) {
		axios.defaults.headers.common['Authorization'] = `Bearer ` + vm.$store.getters.TOKEN;
		axios.post(Vue.config.API_URL + 'notify/all', params)
			.then(function (resp) {


				success(resp.data);


			})
			.catch(function () {

			});
	}

	static loadUserPortfolio() {
		console.log('from api!');
		axios.defaults.headers.common['Authorization'] = `Bearer ` + vm.$store.getters.TOKEN;
		axios.get(Vue.config.API_URL + 'portfolio/all')
			.then(function (resp) {


				eventBus.$emit('load_portfolio_user', resp.data);


			})
			.catch(function () {

			});
	}


	static loadUserInfo(token) {


		axios.defaults.headers.common['Authorization'] = `Bearer ` + token;
		axios.get(Vue.config.API_URL + 'user')
			.then(function (resp) {

				vm.$store.commit('SET_ISAUTH', true);
				resp.data.api_token = token;
				vm.$store.commit('SET_USER', resp.data);

				if (resp.data.isdeveloper == 1) {

					vm.$store.commit('SET_ISDEVELOPER', true);
				} else {
					vm.$store.commit('SET_ISDEVELOPER', false);
				}


				eventBus.$emit('user_is_login', resp.data);
				eventBus.$emit('update_user_info', vm.$store.getters.ISAUTH, vm.$store.getters.ISDEVELOPER);
				var url_after_redirect = localStorage.getItem('url_after_login');
				if (url_after_redirect) {
					url_after_redirect = JSON.parse(url_after_redirect);
					localStorage.removeItem('url_after_login');
					console.log('url after redirect');
					console.log(url_after_redirect);
					vm.$router.push(url_after_redirect);
				}


			})
			.catch(function () {
				//eventBus.$emit('user_is_login', null);
			});
	}
	static loadBlogFormCategorysWithId(category_id,callback,token=undefined){
		var use_token;
		if(token!=undefined){
			use_token=token;
		}else {
			use_token=vm.$store.getters.TOKEN;
		}

		axios.defaults.headers.common['Authorization'] = `Bearer ` + use_token;
		axios.get(Vue.config.API_URL + 'blog/form_categorys?last_id='+category_id)
			.then(function (resp) {


				callback(resp.data);


			})
			.catch(function () {

			});
	}
	static loadBlogFormCategorys(callback,token=undefined){
		var use_token;
		if(token!=undefined){
			use_token=token;
		}else {
			use_token=vm.$store.getters.TOKEN;
		}

		axios.defaults.headers.common['Authorization'] = `Bearer ` + use_token;
		axios.get(Vue.config.API_URL + 'blog/form_categorys')
			.then(function (resp) {


				callback(resp.data);


			})
			.catch(function () {

			});
	}
	static loadBlogCategorys(callback,token=undefined) {
		var use_token;
		if(token!=undefined){
			use_token=token;
		}else {
			use_token=vm.$store.getters.TOKEN;
		}

		axios.defaults.headers.common['Authorization'] = `Bearer ` + use_token;
		axios.get(Vue.config.API_URL + 'blog/categorys')
			.then(function (resp) {


				callback(resp.data);


			})
			.catch(function () {

			});
	}

	static loadCategorys(callback) {


		axios.get(Vue.config.API_URL + 'categorys/all')
			.then(function (resp) {


				callback(resp.data);


			})
			.catch(function () {

			});
	}

	static loadPortfolioCategorys() {

		axios.defaults.headers.common['Authorization'] = `Bearer ` + vm.$store.getters.TOKEN;
		axios.get(Vue.config.API_URL + 'portfolio/categorys')
			.then(function (resp) {


				eventBus.$emit('load_portfolio_categorys', resp.data);


			})
			.catch(function () {

			});
	}

	static loadPortfolioCategorysModal(success) {

		axios.defaults.headers.common['Authorization'] = `Bearer ` + vm.$store.getters.TOKEN;
		axios.get(Vue.config.API_URL + 'portfolio/categorys')
			.then(function (resp) {


				success(resp.data);


			})
			.catch(function () {

			});
	}

	static loadInvoice(id) {


		axios.defaults.headers.common['Authorization'] = `Bearer ` + vm.$store.getters.TOKEN;
		axios.get(Vue.config.API_URL + 'invoices/get/' + id)
			.then(function (resp) {


				if (resp.data.type == "success") {
					eventBus.$emit('is_load_invoice', resp.data);
				}


			})
			.catch(function () {

			});
	}

	static loadProject(id) {


		axios.defaults.headers.common['Authorization'] = `Bearer ` + vm.$store.getters.TOKEN;
		axios.get(Vue.config.API_URL + 'projects/get/' + id)
			.then(function (resp) {


				if (resp.data.type == "success") {

					resp.data.project.json = JSON.parse(resp.data.project.json);
					eventBus.$emit('is_load_project', resp.data);
				}


			})
			.catch(function () {

			});
	}

	static loadInvoices() {


		axios.defaults.headers.common['Authorization'] = `Bearer ` + vm.$store.getters.TOKEN;
		axios.get(Vue.config.API_URL + 'invoices/all')
			.then(function (resp) {


				eventBus.$emit('is_loaded_invoices', resp.data);


			})
			.catch(function () {

			});
	}

	static loadTasksWithFilter(filter,project_id,success){

		axios.defaults.headers.common['Authorization'] = `Bearer ` + vm.$store.getters.TOKEN;
		axios.post(Vue.config.API_URL + 'projects/tasks/'+project_id,{"filter":filter})
			.then(function (resp) {


				return success(resp.data);


			})
			.catch(function () {

			});
	}

	static loadProjectsWithFilter(filter,success){

		axios.defaults.headers.common['Authorization'] = `Bearer ` + vm.$store.getters.TOKEN;
		axios.post(Vue.config.API_URL + 'projects/all',{"filter":filter})
			.then(function (resp) {


				return success(resp.data);


			})
			.catch(function () {

			});
	}

	static loadLeadsTasks(success){
		axios.defaults.headers.common['Authorization'] = `Bearer ` + vm.$store.getters.TOKEN;
		axios.get(Vue.config.API_URL + 'lead/tasksall')
			.then(function (resp) {


				if(resp.data.type && resp.data.type=="success"){
					return success(resp.data);
				}



			})
			.catch(function () {

			});
	}
	static loadProjects(success) {


		axios.defaults.headers.common['Authorization'] = `Bearer ` + vm.$store.getters.TOKEN;
		axios.get(Vue.config.API_URL + 'projects/all')
			.then(function (resp) {


				return success(resp.data);


			})
			.catch(function () {

			});
	}

	static deleteUserPortfolio(id) {

		axios.defaults.headers.common['Authorization'] = `Bearer ` + vm.$store.getters.TOKEN;
		axios.get(Vue.config.API_URL + 'portfolio/delete/' + id)
			.then(function (resp) {


			})
			.catch(function () {

			});
	}

	static removeInvoice(id, project_id, success) {
		axios.defaults.headers.common['Authorization'] = `Bearer ` + vm.$store.getters.TOKEN;
		axios.get(Vue.config.API_URL + 'projects/removeinvoice/' + id + "/" + project_id)
			.then(function (resp) {
				success(resp.data);


			})
			.catch(function () {

			});
	}

	static addProjectInvoice(project_id, newInvoice, success, error) {
		axios.defaults.headers.common['Authorization'] = `Bearer ` + vm.$store.getters.TOKEN;
		axios.post(Vue.config.API_URL + 'projects/addinvoice/' + project_id, newInvoice)
			.then(function (resp) {
				//alert('Успешно!');
				if (resp.data.type == "success") {
					success(resp.data);
				} else {
					error(resp.data.message);
				}

			})
			.catch(function (resp) {
				error("Произошла ошибка!");

			});
	}

	static chooseOfferProject(project_id, offer_id, success) {
		axios.defaults.headers.common['Authorization'] = `Bearer ` + vm.$store.getters.TOKEN;
		axios.get(Vue.config.API_URL + 'freelance/choose/' + project_id + "/" + offer_id)
			.then(function (resp) {
				//alert('Успешно!');
				if (resp.data.type == "success") {
					success(resp.data.project)
				}

			})
			.catch(function (resp) {

			});
	}

	static sendPostSubComment(post_id, comment_id, comment, success) {
		axios.defaults.headers.common['Authorization'] = `Bearer ` + vm.$store.getters.TOKEN;
		axios.post(Vue.config.API_URL + 'blog/comments/sendsub/' + post_id + "/" + comment_id, {"comment": comment})
			.then(function (resp) {
				//alert('Успешно!');
				if (resp.data.type == "success") {
					success(resp.data.comments)
				}

			})
			.catch(function (resp) {

			});
	}

	static sendSubComment(project_id, comment_id, comment, success) {
		axios.defaults.headers.common['Authorization'] = `Bearer ` + vm.$store.getters.TOKEN;
		axios.post(Vue.config.API_URL + 'comments/sendsub/' + project_id + "/" + comment_id, {"comment": comment})
			.then(function (resp) {
				//alert('Успешно!');
				if (resp.data.type == "success") {
					success(resp.data.comments)
				}

			})
			.catch(function (resp) {

			});
	}

	static sendOfferComment(project_id, offer_id, comment, success) {
		axios.defaults.headers.common['Authorization'] = `Bearer ` + vm.$store.getters.TOKEN;
		axios.post(Vue.config.API_URL + 'freelance/sendcomment/' + project_id + "/" + offer_id, {"comment": comment})
			.then(function (resp) {
				//alert('Успешно!');
				if (resp.data.type == "success") {
					success(resp.data.comments)
				}

			})
			.catch(function (resp) {

			});
	}

	static updateLead(lead,lead_id,success,error){
		axios.defaults.headers.common['Authorization'] = `Bearer ` + vm.$store.getters.TOKEN;
		axios.post(Vue.config.API_URL + 'lead/edit/'+lead_id , lead)
			.then(function (resp) {
				//alert('Успешно!');
				if (resp.data.type == "success") {
					success(resp.data);
				} else {
					error(resp.data.message);
				}

			})
			.catch(function (resp) {

				error("Произошла ошибка!");
			});
	}
	static  addLead(new_lead,success,error){
		axios.defaults.headers.common['Authorization'] = `Bearer ` + vm.$store.getters.TOKEN;
		axios.post(Vue.config.API_URL + 'lead/add' , new_lead)
			.then(function (resp) {
				//alert('Успешно!');
				if (resp.data.type == "success") {
					success(resp.data);
				} else {
					error(resp.data.message);
				}

			})
			.catch(function (resp) {

				error("Произошла ошибка!");
			});
	}
	static sendOffer(newOffer, success, error) {
		axios.defaults.headers.common['Authorization'] = `Bearer ` + vm.$store.getters.TOKEN;
		axios.post(Vue.config.API_URL + 'freelance/send/' + newOffer.project_id, newOffer)
			.then(function (resp) {
				//alert('Успешно!');
				if (resp.data.type == "success") {
					success(resp.data.offer)
				} else {
					error(resp.data.message);
				}

			})
			.catch(function (resp) {

				error("Произошла ошибка!");
			});
	}

	static setFinishTask(task_data,lead_id,success,error){
		axios.defaults.headers.common['Authorization'] = `Bearer ` + vm.$store.getters.TOKEN;
		axios.post(Vue.config.API_URL + 'lead/setfinishtask/' + lead_id, task_data)
			.then(function (resp) {
				//alert('Успешно!');
				if (resp.data.type == "success") {
					success(resp.data.all_objects)
				} else {
					error(resp.data.message);
				}

			})
			.catch(function (resp) {

				error("Произошла ошибка!");
			});
	}
    static deleteLeadTask(task_id,lead_id,success,error){
		axios.defaults.headers.common['Authorization'] = `Bearer ` + vm.$store.getters.TOKEN;
		axios.get(Vue.config.API_URL + 'lead/deletetask/' + lead_id+"/"+task_id)
			.then(function (resp) {
				//alert('Успешно!');
				if (resp.data.type == "success") {
					success(resp.data.all_objects)
				} else {
					error(resp.data.message);
				}

			})
			.catch(function (resp) {

				error("Произошла ошибка!");
			});
	}
	static addLeadTask(newTask,lead_id,success,error){
		axios.defaults.headers.common['Authorization'] = `Bearer ` + vm.$store.getters.TOKEN;
		axios.post(Vue.config.API_URL + 'lead/addtask/' + lead_id, newTask)
			.then(function (resp) {
				//alert('Успешно!');
				if (resp.data.type == "success") {
					success(resp.data.all_objects)
				} else {
					error(resp.data.message);
				}

			})
			.catch(function (resp) {

				error("Произошла ошибка!");
			});
	}
	static addLeadComment(newComment, lead_id, success, error) {
		axios.defaults.headers.common['Authorization'] = `Bearer ` + vm.$store.getters.TOKEN;
		axios.post(Vue.config.API_URL + 'lead/addcomment/' + lead_id, newComment)
			.then(function (resp) {
				//alert('Успешно!');
				if (resp.data.type == "success") {
					success(resp.data.all_objects)
				} else {
					error(resp.data.message);
				}

			})
			.catch(function (resp) {

				error("Произошла ошибка!");
			});
	}
	static addPostComment(newComment, post_id, success, error) {
		axios.defaults.headers.common['Authorization'] = `Bearer ` + vm.$store.getters.TOKEN;
		axios.post(Vue.config.API_URL + 'blog/commentadd/' + post_id, newComment)
			.then(function (resp) {
				//alert('Успешно!');
				if (resp.data.type == "success") {
					success(resp.data.comment)
				} else {
					error(resp.data.message);
				}

			})
			.catch(function (resp) {

				error("Произошла ошибка!");
			});
	}

	static addComment(newComment, project_id, success, error) {
		axios.defaults.headers.common['Authorization'] = `Bearer ` + vm.$store.getters.TOKEN;
		axios.post(Vue.config.API_URL + 'comments/add/' + project_id, newComment)
			.then(function (resp) {
				//alert('Успешно!');
				if (resp.data.type == "success") {
					success(resp.data.comment)
				} else {
					error(resp.data.message);
				}

			})
			.catch(function (resp) {

				error("Произошла ошибка!");
			});
	}

	static deleteSpectator(project_id, user_id, success) {
		axios.defaults.headers.common['Authorization'] = `Bearer ` + vm.$store.getters.TOKEN;
		axios.get(Vue.config.API_URL + 'users/delete/' + project_id + "/" + user_id)
			.then(function (resp) {
				//alert('Успешно!');
				if (resp.data.type == "success") {
					success(resp.data.users);


				} else {

					//   error(resp.data.message)
				}

			})
			.catch(function (resp) {
				// error("Произошла ошибка!")

			});
	}
	static deleteInviteLink(project_id,invite_id,success,error){
		axios.defaults.headers.common['Authorization'] = `Bearer ` + vm.$store.getters.TOKEN;
		axios.get(Vue.config.API_URL + 'users/deleteinvite/' + project_id+"/"+invite_id)
			.then(function (resp) {
				//alert('Успешно!');
				if (resp.data.type == "success") {
					success(resp.data.invites);


				} else {

					error(resp.data.message)
				}

			})
			.catch(function (resp) {
				error("Произошла ошибка!")

			});
	}
	static createInviteLinkforProject(project_id,count_invites,success,error){
		axios.defaults.headers.common['Authorization'] = `Bearer ` + vm.$store.getters.TOKEN;
		axios.get(Vue.config.API_URL + 'users/createinvite/' + project_id+"/"+count_invites)
			.then(function (resp) {
				//alert('Успешно!');
				if (resp.data.type == "success") {
					success(resp.data.invites);


				} else {

					error(resp.data.message)
				}

			})
			.catch(function (resp) {
				error("Произошла ошибка!")

			});
	}

	static addUser(project_id, username, success, error) {
		axios.defaults.headers.common['Authorization'] = `Bearer ` + vm.$store.getters.TOKEN;
		axios.post(Vue.config.API_URL + 'users/add/' + project_id, {"username": username})
			.then(function (resp) {
				//alert('Успешно!');
				if (resp.data.type == "success") {
					success(resp.data.users);


				} else {

					error(resp.data.message)
				}

			})
			.catch(function (resp) {
				error("Произошла ошибка!")

			});
	}

	static setAccount(formdata, success, error) {
		axios.defaults.headers.common['Authorization'] = `Bearer ` + vm.$store.getters.TOKEN;
		axios.post(Vue.config.API_URL + 'setaccount', formdata)
			.then(function (resp) {
				//alert('Успешно!');
				if (resp.data.type == "success") {
					success();


				} else {

					error(resp.data.message)
				}

			})
			.catch(function (resp) {
				error("Произошла ошибка!")

			});
	}

	static setNewStatus(status_id, project_id, success) {
		axios.defaults.headers.common['Authorization'] = `Bearer ` + vm.$store.getters.TOKEN;
		axios.get(Vue.config.API_URL + 'projects/newstatus/' + project_id + "/" + status_id)
			.then(function (resp) {


				success(resp.data);


			})
			.catch(function () {

			});
	}

	static approveInvoice(id, project_id, success) {
		axios.defaults.headers.common['Authorization'] = `Bearer ` + vm.$store.getters.TOKEN;
		axios.get(Vue.config.API_URL + 'projects/approveinvoice/' + id + "/" + project_id)
			.then(function (resp) {


				success(resp.data);


			})
			.catch(function () {

			});
	}

	static completeInvoice(id, project_id, success) {
		axios.defaults.headers.common['Authorization'] = `Bearer ` + vm.$store.getters.TOKEN;
		axios.get(Vue.config.API_URL + 'projects/completeinvoice/' + id + "/" + project_id)
			.then(function (resp) {

				success(resp.data);


			})
			.catch(function () {

			});
	}

	static login(to, next) {
		console.log('to route');
		console.log(to);
		var token = localStorage.getItem('api_token');

		axios.defaults.headers.common['Authorization'] = `Bearer ` + token;
		axios.get(Vue.config.API_URL + 'user')
			.then(function (resp) {

				next();

			})
			.catch(function () {
				localStorage.setItem('url_after_login', JSON.stringify(to));
				vm.$router.push({"name": "landing"});


				// this.$router.push({"name": "project", "params": {"id": button.params.id, "rand": Math.random()}});
				// vm.$forceUpdate();
				// window.location.href = "/";
			});
	}

	static addWork(newWork, success, error) {
		axios.defaults.headers.common['Authorization'] = `Bearer ` + vm.$store.getters.TOKEN;
		axios.post(Vue.config.API_URL + 'portfolio/add', newWork)
			.then(function (resp) {
				//alert('Успешно!');
				if (resp.data.type == "success") {
					success();

				} else {
					error(resp.data.message);

				}

			})
			.catch(function (resp) {

				error("Произошла ошибка!");
			});
	}

	static invoiceSetPay(id, callback) {
		axios.defaults.headers.common['Authorization'] = `Bearer ` + vm.$store.getters.TOKEN;
		axios.get(Vue.config.API_URL + 'invoices/setpay/' + id)
			.then(function (resp) {

				if (resp.data.type == "success") {
					callback();
				}


			})
			.catch(function () {

			});
	}

	static invoiceFinishPay(id, callback) {
		axios.defaults.headers.common['Authorization'] = `Bearer ` + vm.$store.getters.TOKEN;
		axios.get(Vue.config.API_URL + 'invoices/finishpay/' + id)
			.then(function (resp) {

				if (resp.data.type == "success") {
					callback()
				}


			})
			.catch(function () {

			});
	}

	static addTask(editProject, success, error) {
		axios.defaults.headers.common['Authorization'] = `Bearer ` + vm.$store.getters.TOKEN;
		axios.post(Vue.config.API_URL + 'projects/addtask/' + editProject.last_id, editProject)
			.then(function (resp) {
				//alert('Успешно!');
				if (resp.data.type == "success") {

					success(resp.data.tasks);
				} else {

					error(resp.data.message);
				}

			})
			.catch(function (resp) {
				error("Произошла ошибка");

			});
	}

	static editProject(editProject, success, error) {
		axios.defaults.headers.common['Authorization'] = `Bearer ` + vm.$store.getters.TOKEN;
		axios.post(Vue.config.API_URL + 'projects/edit_project/' + editProject.last_id, editProject)
			.then(function (resp) {
				//alert('Успешно!');
				if (resp.data.type == "success") {

					success({iserror: false});
				} else {

					error(resp.data.message);
				}

			})
			.catch(function (resp) {
				error("Произошла ошибка");

			});
	}

	static changeEnablePost(post_id, success) {
		axios.defaults.headers.common['Authorization'] = `Bearer ` + vm.$store.getters.TOKEN;
		axios.get(Vue.config.API_URL + 'blog/enable/' + post_id)
			.then(function (resp) {
				//alert('Успешно!');
				if (resp.data.type == "success") {

					success(resp.data.post);
				}

			})
			.catch(function (resp) {


			});
	}

	static createPost(newPost, callback) {
		axios.defaults.headers.common['Authorization'] = `Bearer ` + vm.$store.getters.TOKEN;
		axios.post(Vue.config.API_URL + 'blog/addpost', newPost)
			.then(function (resp) {
				//alert('Успешно!');
				if (resp.data.type == "success") {

					callback({iserror: false, post_id: resp.data.post_id,alias:resp.data.alias});
				} else {

					callback({iserror: true, error_message: resp.data.message});
				}

			})
			.catch(function (resp) {
				callback({iserror: true, error_message: "Произошла ошибка"});

			});
	}

	static createProject(newProject, callback) {
		axios.defaults.headers.common['Authorization'] = `Bearer ` + vm.$store.getters.TOKEN;
		axios.post(Vue.config.API_URL + 'projects/add', newProject)
			.then(function (resp) {
				//alert('Успешно!');
				if (resp.data.type == "success") {

					callback({iserror: false, project_id: resp.data.project_id});
				} else {

					callback({iserror: true, error_message: resp.data.message});
				}

			})
			.catch(function (resp) {
				callback({iserror: true, error_message: "Произошла ошибка"});

			});
	}

	static loadDeveloperReviews(username, success) {


		axios.get(Vue.config.API_URL + 'developer/reviews/' + username)
			.then(function (resp) {

				if (resp.data.type == "success") {
					var developer_data = resp.data.developer;


					success(developer_data);
				}


			})
			.catch(function () {

			});
	}

	static loadDeveloperWork(username, work_id, success) {


		axios.get(Vue.config.API_URL + 'developer/work/' + username + "/" + work_id)
			.then(function (resp) {

				if (resp.data.type == "success") {
					var developer_data = resp.data.developer;
					var work = resp.data.work;


					success(developer_data, work);
				}


			})
			.catch(function () {

			});
	}

	static loadDeveloper(username) {


		axios.get(Vue.config.API_URL + 'developer/' + username)
			.then(function (resp) {

				if (resp.data.type == "success") {
					var developer_data = resp.data.developer;


					eventBus.$emit('load_developer_user', developer_data);
				}


			})
			.catch(function () {

			});
	}

	static loadUserPortfolio() {

		axios.defaults.headers.common['Authorization'] = `Bearer ` + vm.$store.getters.TOKEN;
		axios.get(Vue.config.API_URL + 'portfolio/all')
			.then(function (resp) {


				eventBus.$emit('load_portfolio_user', resp.data);


			})
			.catch(function () {

			});
	}


}